import React from 'react';
import { Container, Grid, Typography, Box, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, YouTube, WhatsApp } from '@mui/icons-material';

const Footer = () => {
    
     const linkStyle = { color: 'inherit', textDecoration: 'none' };
    
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#2C2E2F', // Dark blue color
        padding: '20px 0',
        marginTop: 'auto',
        borderTop: '1px solid #e0e0e0',
        color: '#ffffff', // White text color for contrast
      }}
    >
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
           <Box textAlign="center" mt={4}>
          <Typography variant="body2" color="inherit">
            © {new Date().getFullYear()} FoodSakz Online Grocery Shop. All rights reserved
          </Typography>
        </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6">Follow Us</Typography>
 <IconButton color="inherit" component="a"
    href="https://www.facebook.com/profile.php?id=61582746269846"
    target="_blank"><Facebook /></IconButton>
        <IconButton color="inherit" component="a"
    href="https://www.instagram.com/foodsakz/"
    target="_blank"><Instagram /></IconButton>
        <IconButton color="inherit" component="a"
    href="https://x.com/foodsakz"
    target="_blank"><Twitter /></IconButton>
        <IconButton color="inherit" component="a"
    href="https://www.youtube.com/@Foodsakz"
    target="_blank"><YouTube /></IconButton>
        <IconButton color="inherit" component="a"
    href="https://wa.me/message/UCWLVVPCYBD6J1"
    target="_blank"><WhatsApp /></IconButton>
            <Typography variant="body2">
        <p>WhatsApp : +91 999 464 1128</p>
        <p>Email: <a href="mailto:info@foodsakz.com">info@foodsakz.com</a> </p>
            </Typography>
          </Grid>
        </Grid>
      
      </Container>
    </Box>
  );
};

export default Footer;
